module.exports = __webpack_public_path__ + "img/jala-harvest.1e84ac33.png";